import { Routes, Route } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import AuthLayout from "../layouts/AuthLayout";
import ProtectedRoute from "../components/routes/ProtectedRoute";
import Login from "../pages/Auth/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import ReportList from "../pages/Reports/ReportList";
import ReportExtensions from "../pages/Reports/ReportExtensions";
import UpdateStatus from "../pages/Reports/UpdateStatus";
import ReportsStatistic from "../pages/Reports/ReportsStatistic";
import ReportsUserStat from "../pages/Reports/ReportsUserStat";
import ExportReport from "../pages/Reports/ExportReport";
import NewsManager from "../pages/News/NewsManager";
import ProceduresManager from "../pages/Procedures/ProceduresManager";
import TemplateManager from "../pages/Templates/TemplateManager";
import ContactInfo from "../pages/Contact/ContactInfo";
import WorkSchedule from "../pages/Schedules/WorkSchedule";
import AdminManager from "../pages/AdminAccounts/AdminManager";
import NotFound from "../pages/NotFound";
import Statistics from "../pages/Statistic/Statistic";
import ROUTE_PATH from "../constants/routes";
import ReportAreasManagement from "../pages/ReportAreas/ReportAreasManagement";
import AreaManagement from "../pages/Areas/AreaManagement";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import GovernmentManagement from "../pages/Government/GovernmentManagement";
import PermissionsManagement from "../pages/Permissions/PermissionsManagement";
import RoleFormPage from "../pages/Permissions/RoleFormPage";
import AuditLogManagement from "../pages/AuditLog/AuditLogManagement";
import CategoryNewsManagement from "../pages/CategoryNews/CategoryNewsManagement";
import CounterReceptionFeedbackPage from "../pages/Schedules/CounterReceptionFeedbackPage";
import LeaderMeetingFeedbackPage from "../pages/Schedules/LeaderMeetingFeedbackPage";
import AddLeaderSchedule from "../pages/Schedules/AddLeaderSchedule";
import LeaderMeetingRatingsPage from "../pages/Schedules/LeaderMeetingRatingsPage";
import ReceptionKiosk from "../pages/Kiosk/ReceptionKiosk";
import DocumentsManagement from "../pages/Documents/DocumentsManagement";
import DocumentCategoriesManagement from "../pages/Documents/DocumentCategoriesManagement";

function AppRoutes() {
    return (
        <Routes>
            <Route element={<AuthLayout />}>
                <Route path={ROUTE_PATH.LOGIN} element={<Login />} />
            </Route>

            <Route element={<AuthLayout />}>
                <Route path={ROUTE_PATH.FORGOT_PASSWORD} element={<ForgotPassword />} />
            </Route>

            {/* Kiosk Tiếp dân (Public / Fullscreen) */}
            <Route path={ROUTE_PATH.KIOSK_TIEP_DAN} element={<ReceptionKiosk />} />
            <Route path="/kiosk/tiep-dan" element={<ReceptionKiosk />} />

            <Route element={
                <ProtectedRoute>
                    <AdminLayout />
                </ProtectedRoute>
            }>
                <Route path={ROUTE_PATH.DASHBOARD} element={<Dashboard />} />
                <Route path={ROUTE_PATH.REPORT} element={<ReportList />} />
                <Route path={ROUTE_PATH.REPORT_EXTENSIONS} element={<ReportExtensions />} />
                <Route path="/reports/extensions" element={<ReportExtensions />} />
                <Route path={ROUTE_PATH.REPORT_UPDATE} element={<UpdateStatus />} />
                <Route path={ROUTE_PATH.REPORT_STATISTICS} element={<ReportsStatistic />} />
                <Route path={ROUTE_PATH.REPORT_USERS} element={<ReportsUserStat />} />
                <Route path={ROUTE_PATH.REPORT_EXPORT} element={<ExportReport />} />
                <Route path={ROUTE_PATH.NEWS} element={<NewsManager />} />
                <Route path={ROUTE_PATH.PROCEDURES} element={<ProceduresManager />} />
                <Route path={ROUTE_PATH.TEMPLATES} element={<TemplateManager />} />
                <Route path={ROUTE_PATH.CONTACT} element={<ContactInfo />} />
                <Route path={ROUTE_PATH.SCHEDULES} element={<WorkSchedule />} />
                <Route path={ROUTE_PATH.STATISTICS} element={<Statistics />} />
                <Route path={ROUTE_PATH.ACCOUNTS} element={<AdminManager />} />
                <Route path={ROUTE_PATH.REPORT_AREAS} element={<ReportAreasManagement />} />
                <Route path={ROUTE_PATH.AREAS} element={<AreaManagement />} />
                <Route path={ROUTE_PATH.GOVERNMENT} element={<GovernmentManagement />} />
                <Route path={ROUTE_PATH.PERMISSIONS} element={<PermissionsManagement />} />
                <Route path={ROUTE_PATH.ROLE_CREATE} element={<RoleFormPage />} />
                <Route path={ROUTE_PATH.ROLE_EDIT} element={<RoleFormPage />} />
                <Route path={ROUTE_PATH.AUDIT_LOG} element={<AuditLogManagement />} />
                <Route path={ROUTE_PATH.CATEGORY_NEWS} element={<CategoryNewsManagement />} />
                <Route path={ROUTE_PATH.DOCUMENTS} element={<DocumentsManagement />} />
                <Route path={ROUTE_PATH.DOCUMENTS_HISTORY} element={<DocumentsManagement />} />
                <Route path={ROUTE_PATH.DOCUMENTS_LEGAL} element={<DocumentsManagement />} />
                <Route path={ROUTE_PATH.DOCUMENTS_CATEGORIES} element={<DocumentCategoriesManagement />} />
                <Route path={ROUTE_PATH.COUNTER_RECEPTION_FEEDBACK} element={<CounterReceptionFeedbackPage />} />
                <Route path={ROUTE_PATH.LEADER_MEETING_FEEDBACK} element={<LeaderMeetingFeedbackPage />} />
                <Route path={ROUTE_PATH.ADD_LEADER_SCHEDULE} element={<AddLeaderSchedule />} />
                <Route path={ROUTE_PATH.LEADER_MEETING_RATINGS} element={<LeaderMeetingRatingsPage />} />

                <Route path="/reports/:id" element={<ReportList />} />
            </Route>

            <Route path={ROUTE_PATH.NOT_FOUND} element={<NotFound />} />
        </Routes>
    );
}

export default AppRoutes;
